import { render, staticRenderFns } from "./ModalLayout.vue?vue&type=template&id=4de2a324&scoped=true&"
import script from "./ModalLayout.vue?vue&type=script&lang=js&"
export * from "./ModalLayout.vue?vue&type=script&lang=js&"
import style0 from "./ModalLayout.vue?vue&type=style&index=0&id=4de2a324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2a324",
  null
  
)

export default component.exports